import { IKeywordItem } from '@umu/umu-types';
import { config } from 'common';
const { KEYWORD_COLORS } = config;
import { IWord } from './wordCloud/cloud';

interface IFontSizes {
    [key: string]: number;
}

const FONT_SIZES = {
    LARGE: 34,
    MEDIUM: 28,
    SMALL: 16,
};

const FREQUENCY_WORD_COLORS = {
    LARGE: '#2096F3',
    MEDIUM: '#57AFF5',
    SMALL: '#AFDCFF',
};

const enum wordPriority {
    LARGE = 'LARGE',
    MEDIUM = 'MEDIUM',
    SMALL = 'SMALL',
}

const enum wordType {
    NORMAL,
    FREQUENCY,
}

interface IColoredKeyword extends IKeywordItem {
    type: wordType;
    priority: wordPriority;
}

export function getWordCloudData(
    keywords: IKeywordItem[],
    frequencyWords: IKeywordItem[],
    fontSizes?: IFontSizes,
): IWord[] {
    keywords = keywords.filter((v) => v.count > 0);
    const allWords = transFormWord(keywords, frequencyWords);
    return allWords.map((keyword, index) => {
        return {
            text: keyword.word,
            color: getWordColor(keyword, index),
            fontSize: getWrodSize(keyword, fontSizes),
            fontWeight: getWordWeight(keyword),
        };
    });
}

function transFormWord(keywords: IKeywordItem[], frequencyWords: IKeywordItem[]) {
    let tmp = keywords.map((word) => {
        return {
            type: wordType.NORMAL,
            ...word,
        };
    });
    tmp = tmp.concat(
        frequencyWords.map((word) => {
            return {
                type: wordType.FREQUENCY,
                ...word,
            };
        }),
    );

    const max = Math.max(...tmp.map((wordItem) => wordItem.count));

    return tmp.map((wordItem) => {
        return {
            priority: getWordPriority(wordItem, max),
            ...wordItem,
        };
    });
}

/**
 *  根据 count 值将单词划分为三个等级
 */
function getWordPriority(word: IKeywordItem, max: number): wordPriority {
    if (word.count > (max * 2) / 3) {
        return wordPriority.LARGE;
    } else if (word.count > (max * 1) / 3) {
        return wordPriority.MEDIUM;
    } else {
        return wordPriority.SMALL;
    }
}

function getWrodSize(keyword: IColoredKeyword, fontSizes: IFontSizes = FONT_SIZES) {
    return fontSizes[keyword.priority];
}

function getWordColor(keyword: IColoredKeyword, index: number) {
    if (keyword.type === wordType.FREQUENCY) {
        return FREQUENCY_WORD_COLORS[keyword.priority];
    } else {
        return KEYWORD_COLORS[index % KEYWORD_COLORS.length];
    }
}

function getWordWeight(word: IColoredKeyword) {
    if (word.priority === wordPriority.LARGE) {
        return 'bold';
    } else {
        return 'normal';
    }
}
